export enum PledgesActionType {
    HaltRealtimePledges = 'HALT_REALTIME_PLEDGES',
    ResumeRealtimePledges = 'RESUME_REALTIME_PLEDGES',
    ResetPledgeDetail = 'RESET_PLEDGE_DETAIL'
}

export interface PledgesAction {
    type: PledgesActionType;
    payload?: any;
}

export const haltRealtimePledgeAction: PledgesAction = { type: PledgesActionType.HaltRealtimePledges };
export const resumeRealtimePledgeAction: PledgesAction = { type: PledgesActionType.ResumeRealtimePledges };
export const resetPledgeDetailAction: PledgesAction = { type: PledgesActionType.ResetPledgeDetail };